"use client";
import DataObject from '@mui/icons-material/DataObject';
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Box } from "@mui/system";
import React, { useState } from "react";
import ReportRowActions from "~/app/admin/versuri/probleme/ReportRowActions";
import LyricsPatchDialog from "~/components/lyrics/LyricsPatchDialog";
import { formatDateTime } from "~/lib/formatDate";
import type { LyricsPatch, LyricsReport } from "~/types";
import Link from '../Link';

interface Props {
  reports: LyricsReport[];
  showUrl?: boolean;
  onReportsChange?: () => void | Promise<void>;
}

export default function LyricsReportsTable({ reports, showUrl = false, onReportsChange }: Props) {
  const [openPatches, setOpenPatches] = useState(false);
  const [selectedPatches, setSelectedPatches] = useState<LyricsPatch | null>(null);

  const handleRowClick = (row: LyricsReport) => {
    if (row.patches) {
      setSelectedPatches(row.patches);
      setOpenPatches(true);
    }
  };

  const handleClose = () => {
    setOpenPatches(false);
    setSelectedPatches(null);
  };

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Raport</TableCell>
            <TableCell width={90}>Acțiuni</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {reports.map((row) => {
            const rawSlug = row.url ? row.url.split("/").filter(Boolean).pop() : null;
            const slug = rawSlug ? rawSlug.split("?")[0].split("#")[0] : null;
            const href = slug ? `/versuri/cantec/${slug}` : row.url ?? "#";

            return (
              <React.Fragment key={row.id}>
                <TableRow sx={{ bgcolor: row.status === "resolved" ? "success.light" : "inherit", cursor: row.patches ? 'pointer' : 'default' }} onClick={() => handleRowClick(row)}>
                  <TableCell sx={{ maxWidth: 480, wordBreak: "break-word", py: 1 }}>
                    <Box sx={{ fontWeight: 500, display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                      <Box>
                        #{row.id}
                      </Box>
                      {showUrl && (
                        <Box sx={{ fontWeight: 700 }}>
                          <Link href={href} target="_blank" effect='color-on-hover' sx={{ color: "inherit" }}>
                            {slug ?? row.url}
                          </Link>
                        </Box>
                      )}
                      <Box>
                        <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
                          <Box>{row.category}</Box>
                          {row.patches ? (
                            <DataObject fontSize="small" color="action" />
                          ) : null}
                        </Box>
                      </Box>
                    </Box>
                    <Box sx={{ fontSize: 12, color: "rgba(0,0,0,0.6)" }}>{formatDateTime(row.createdAt)}</Box>

                  </TableCell>
                  <TableCell onClick={(e) => e.stopPropagation()}>
                    <ReportRowActions report={row} onRefresh={onReportsChange} />
                  </TableCell>
                </TableRow>
                <TableRow sx={{ bgcolor: row.status === "resolved" ? "success.light" : "inherit", borderBottom: "1px solid", borderColor: "divider" }}>
                  <TableCell colSpan={2} sx={{ py: 0.5, }}>
                    <Box sx={{ whiteSpace: "pre-wrap", }}>{row.description}</Box>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>
      <LyricsPatchDialog open={openPatches} onClose={handleClose} patches={selectedPatches} />
    </TableContainer>
  );
}
